import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconProductPlacementStyle0 = cosmosIconCss;

const CosmosIconProductPlacement$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconProductPlacement extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '82915d4c673238e85ae5439170fbdbb9bdaf6424', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9b9f76c811cb7ce928bf4747b7f124d84a486697', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a216450721d3c8e65f8c9a194cba02cfd4bafe0d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 2.002 19.36 2c.223 0 .304.023.385.067a.454.454 0 0 1 .19.189c.043.081.066.162.066.385v16.718c0 .223-.023.304-.067.385a.454.454 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.454.454 0 0 1-.19-.189.59.59 0 0 1-.064-.285L2 2.641c0-.223.023-.304.067-.385a.454.454 0 0 1 .189-.19.59.59 0 0 1 .285-.064ZM18.5 3.5h-15v15h15v-15Zm-8.356 11.501V12.16h1.092c.424 0 .806-.06 1.146-.18.34-.12.63-.29.87-.51.24-.22.424-.49.552-.81.128-.32.192-.68.192-1.08 0-.8-.244-1.43-.732-1.89C12.776 7.23 12.1 7 11.236 7H8.44v8.001h1.704Zm.972-4.233h-.972v-2.34h.972c.36 0 .64.102.84.306.2.204.3.49.3.858 0 .36-.1.646-.3.858-.2.212-.48.318-.84.318Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconProductPlacementStyle0; }
}, [1, "cosmos-icon-product-placement", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-product-placement"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-product-placement":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconProductPlacement$1);
            }
            break;
    } });
}

const CosmosIconProductPlacement = CosmosIconProductPlacement$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconProductPlacement, defineCustomElement };
